import {gateway} from '../config/api';

export function setHeaders(token?: string) {
  gateway().defaults.headers.common.Authorization = token
    ? `Bearer ${token}`
    : '';
}
